module.exports = __webpack_public_path__ + "img/equipment_1.59508f2b.svg";